import apiAuth from '@/api/auth'
import apiClient from '@/api/client'
import api from '@/api'
import Cookies from '@/services/cookies'
import router from '@/router'
import * as types from './mutation_types'
import * as typesSignin from '@/store/signin/mutation_types'
import { assign } from 'lodash'
import { BRAND_ID_H } from '@/config/constants'

export default {
  sendSms: async ({ state, getters, commit, rootGetters, dispatch }, data) => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())

    if (!Cookies.get('_ga')) {
      const gaCookie = window.generateGaClientIdCookie()
      Cookies.set('_ga', gaCookie, { expires: 730 })
    }

    if (!Cookies.get('_efst')) {
      try {
        await dispatch('efst/getFrontSmsToken', false, { root: true })
      } catch (error) {
        console.error(error)
      }
    }

    const analyticalData = {
      cookie: Cookies.get(),
      utm: params,
      referrer: Cookies.get('document_referrer'),
      host: window.location.hostname,
    }

    const client = {
      phone: data.phone,
      cityId: rootGetters['city/getActive'].id,
    }

    const { recaptchaToken } = data
    if (recaptchaToken) {
      client.recaptchaToken = recaptchaToken
    }

    let response
    try {
      response = await apiAuth.sendSms({
        analyticalData,
        client,
        brandId_H: BRAND_ID_H,
      })
    } catch (error) {
      return Promise.reject(error)
    }
    commit(
      `signin/${typesSignin.SET_PHONE_BEFORE_SIGNIN}`,
      { phone: data },
      { root: true },
    )
    return response?.data
  },

  checkSms: async ({ state, getters, dispatch, commit, rootGetters }, data) => {
    let response
    try {
      response = await apiAuth.loginByCode({
        phone: data.phone,
        password: data.code || data.password,
        brandId_H: rootGetters.brandId,
      })
    } catch (error) {
      return Promise.reject(error)
    }
    commit(types.SET_CLIENT_TOKEN, response?.data?.client_token)
    commit(types.SET_CLIENT, { profile: response?.data?.profile })
    commit(
      `signin/${typesSignin.SET_PHONE_BEFORE_SIGNIN}`,
      { phone: '' },
      { root: true },
    )
    dispatch('analytics/setUserId', response?.data?.profile, { root: true })
    // Применяем бонусы за приглашения друга
    dispatch('invite/chargeBonus', null, { root: true })
    return response?.data
  },

  /**
   * @param {object} data
   * @param {string} data.phone
   * @param {string} data.code
   */
  login: async ({ rootState, rootGetters, state, commit, dispatch }, data) => {
    // отправляем его по api
    let response

    try {
      response = await apiAuth.login({
        phone: data.phone,
        password: data.password,
        cityId: rootGetters.cityId || 1,
        brandId: rootGetters.brandId || 1,
      })
    } catch (error) {
      return Promise.reject(error)
    }

    dispatch('analytics/setUserId', response.data.profile, { root: true })
    commit(types.SET_CLIENT, response.data.profile)
    commit(types.SET_CLIENT_TOKEN, response.data.token)

    return response.data
  },

  logout: async ({ dispatch, commit }, { withoutLogoutRequest = false }) => {
    commit(types.LOGOUT, { withoutLogoutRequest })
    // TODO: выпилить костыль
    dispatch('vcp/getVcpConfig', {}, { root: true })
    // снимаем флаг для бонусной программы
    if (JSON.parse(localStorage.getItem('referralBonusWasCharged'))) localStorage.setItem('referralBonusWasCharged', null)
  },

  setToken: ({ dispatch, commit }, clientToken) => {
    const token = window.localStorage.getItem('client_token')
    if (token) {
      return
    }
    commit(types.SET_CLIENT_TOKEN, clientToken)
    dispatch('checkToken')
  },

  checkToken: async ({ dispatch, commit }) => {
    const token = window.localStorage.getItem('client_token')
    api.setToken(token)

    let response
    try {
      response = await apiAuth.getProfile()
      commit(types.SET_CLIENT, response.data)
      dispatch('analytics/setUserId', response.data.profile, { root: true })
    } catch (error) {
      return Promise.reject(error)
    }

    return response
  },

  /**
   * @param {object} data
   * @param {string} data.first_name
   * @param {string} data.last_name
   * @param {string} data.phone
   */
  registerUser: async ({ commit }, data) => {
    let response
    try {
      response = await apiAuth.register(data)
    } catch (error) {
      return Promise.reject(error)
    }

    return response
  },

  /**
   * @param {object} data
   */
  updateProfile: async ({ commit }, data) => {
    let response
    try {
      response = await apiAuth.updateProfile(data)
      commit(types.SET_CLIENT, response.data)
    } catch (error) {
      return Promise.reject(error)
    }

    return response
  },

  setClientProfile: async ({ commit }, data) => {
    let response
    try {
      response = await apiClient.postClientProfile(data)
      // console.log('postClientProfile', response.data)
      commit(types.SET_CLIENT, response.data.profile)
    } catch (error) {
      return Promise.reject(error)
    }
    return response
  },

  /**
   * @param {object} phone
   */
  sendAppLink: async ({ commit }, payload) => {
    let response
    let errorMessage
    try {
      response = await apiClient.sendAppLink(payload)
    } catch (error) {
      errorMessage = error?.response?.data?.messages[0]
      console.error(error)
    }
    return { response, errorMessage }
  },

  /**
   * @description Получение списка адресов
   * @param commit
   * @return {Promise<void>}
   */
  getAddresses: async ({ commit }, addresses = null) => {
    try {
      const response = await apiClient.getClientAddress()

      const { data: { addresses = [] } = {} } = response

      commit('SET_ADDRESSES', addresses)
    } catch (error) {
      console.error('client.getAddresses.error =>', error)
    }
  },

  /**
   * Обновление списка адресов
   *
   * @param commit
   * @param addresses
   */
  setAddresses: ({ commit }, addresses) => {
    commit('SET_ADDRESSES', addresses)
  },

  /**
   * @description Обновление адреса в списке адресов по его id_H
   * @param commit
   * @param address
   */
  updateAddress: ({ commit }, address) => {
    commit('ADD_OR_UPDATE_ADDRESS', address)
  },

  /**
   * @description расчет Параметров ИМТ для незарега
   * @param {Number} payload.height Number рост
   * @param {Number} payload.weight вес
   * @param {String} payload.menuTypeGroupId_H айди потребности
   * @param {String} payload.lifestyleId_H айди лайфстайла
   * @param {Number} payload.purposeWeight желаемый вес
   * @param {Boolean} payload.eatsSomethingElse ест что то кроме гроуфда
   * @param {String} payload.gender пол
   * @param {String} payload.birthday день рождения yyyy-mm-dd
   */
  calculateImt: ({ commit }, payload) =>
    new Promise((resolve, reject) => {
      apiClient
        .calculateImt(payload)
        .then((response) => {
          window.localStorage.setItem(
            'unauthorizedImtData',
            JSON.stringify({ ...response.data.bmiInfo, ...payload }),
          )
          commit(types.SET_UNAUTHORIZED_IMT_DATA, {
            ...response.data.bmiInfo,
            ...payload,
          })
          resolve(response)
        })
        .catch((error) => reject(error))
    }),
  clearUnauthorizedClientDetails: ({ commit }) => {
    window.localStorage.removeItem('unauthorizedImtData')
    commit(types.SET_UNAUTHORIZED_IMT_DATA, {})
  },
  setPreloadedMenus: ({ commit }, data) => {
    commit(types.SET_PRELOADED_MENUS, data)
  },
  updatePreloadedMenus: ({ state, commit }, data) => {
    commit(types.SET_PRELOADED_MENUS, assign({}, state.preloadedMenus, data))
  },
  updateUnauthorizedImtData: ({ commit, getters }, data) =>
    new Promise((resolve, reject) => {
      window.localStorage.setItem(
        'unauthorizedImtData',
        JSON.stringify({ ...getters.unauthorizedImtData, ...data }),
      )
      commit(types.SET_UNAUTHORIZED_IMT_DATA, {
        ...getters.unauthorizedImtData,
        ...data,
      })
    }),
  checkUnauthorizedImtData: ({ commit }) =>
    new Promise((resolve, reject) => {
      const unauthorizedImtData = window.localStorage.getItem(
        'unauthorizedImtData',
      )
      if (unauthorizedImtData) {
        commit(types.SET_UNAUTHORIZED_IMT_DATA, JSON.parse(unauthorizedImtData))
      }
    }),
  /**
   * @description получение списка лайфстайлов
   * TODO: записывать в стор и брать оттуда?
   */
  getLifestyles: async () => {
    let response
    try {
      response = await apiClient.getLifestyles()
    } catch (error) {
      return Promise.reject(error)
    }

    return response.data
  },
  updateClientDetails: ({ dispatch }, payload) =>
    new Promise((resolve, reject) => {
      apiClient
        .updateClientDetails(payload)
        .then((response) => {
          dispatch('checkToken').then((r) => {
            resolve(response.data)
          })
        })
        .catch((error) => reject(error))
    }),
  /**
   * @description Добавление адреса в список адресов клиента
   *
   * @param commit
   *
   * @param clientAddressIdH - Для обновления текущего адреса
   * @param address - объект с инфой о адресе
   *
   * @return {Promise<*|boolean>}
   */
  addAddress: async ({ commit }, { clientAddressIdH = '', address }) => {
    const request = {
      addressInfo: address,
    }

    if (clientAddressIdH) {
      request.clientAddressId_H = clientAddressIdH
    }

    try {
      const response = await apiClient.postClientAddress(request)
      const { data: { addresses = [] } = {} } = response

      commit('SET_ADDRESSES', addresses)

      return addresses
    } catch (error) {
      return error
    }
  },
  /**
   * @param payload название обучалки
   * @description Создание записи в профилое о просмотре обучения
   */
  setClientTour: ({ commit }, payload) => new Promise((resolve, reject) => {
    apiClient.setClientTour({ tourName: payload }).then(response => {
      commit(types.SET_CLIENT_TOURS, { tourName: payload })
      resolve(response.body)
    }).catch(error => reject(error))
  }),
  /**
   * @description Добавление шаблона питания клиенту локально в браузере (параметр у профиля menuCalendarConfig)
   *
   * @param commit
   *
   * @param {Object} filter - объект с инф-й о примененных у пользователя шаблонах питания
   * @param {?number} filter.meals - id шабонов "без обьеда" или "без завтрака и ужина"
   * @param {?number} filter.days - id шабонов "без выходных" (1)
   *
   * @return {Promise<*|boolean>}
   */
  setMenuCalendarConfig: ({ dispatch, commit, state }, filter) => {
    if (state.profile) {
      const filterObj = Object.assign({}, state.profile.menuCalendarConfig, filter)
      const profile = Object.assign({}, state.profile, { menuCalendarConfig: filterObj })
      commit(types.SET_CLIENT, { profile })
    }
  },

  longateBonuses: ({ commit }, burnId) => new Promise((resolve, reject) => {
    apiClient.longateBonuses({ burnId_H: burnId })
      .then(response => { resolve(response.body) })
      .catch(error => {
        router.push({ name: 'Landing' })
        reject(error)
      })
  }),
}
